import React, { useContext, useEffect, useRef, useState } from 'react';
import { StyledSessionsListSection, MainMenu, MenuBtn, StyledMenuItem } from './SessionsListSection.style';
import sessionsService from '../../../services/sessionsServices';
import { TemporaryChatContext } from '../../../Context/temporaryChatContext';
import { useLocation, useNavigate } from 'react-router-dom';
import Loaders from '../../Loaders';
import { PiDotsThreeOutlineVertical } from 'react-icons/pi';
import ModalContainer from '../../ModalContainer';
import RenameChatModal from '../RenameChatModal';
import DeleteChatModal from '../DeleteChatModal';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import Toast from '../../Toast';

const SessionsListSection = ({ selectedAgent }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const location = useLocation();

  const dropdownRef = useRef(null);
  const { toggleRef } = useContext(TemporaryChatContext);
  const payload = {
    platform_id: 'dryvelabs',
    agent_id: selectedAgent?.value,
    project_id: 'test',
  };

  const { data, isPending } = useQuery({
    queryKey: ['sessions', 'sidebar_sessions', payload],
    queryFn: async () => {
      return sessionsService.getSessionsList(payload);
    },
  });
  const [chatDropdownOpen, setChatDropdownOpen] = useState(null);

  const handleAddFavorite = useMutation({
    mutationFn: async id => {
      return await sessionsService?.updateSession({
        platform_id: 'dryvelabs',
        session_id: id,
        agent_id: 'ferdy',
        is_favorite: true,
      });
    },
    retry: 1,
    onSuccess: response => {
      Toast({
        type: 'success',
        message: response.detail,
      });
      queryClient.invalidateQueries({ queryKey: ['sessions'] });
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  const handleRemoveFavorite = useMutation({
    mutationFn: async id => {
      return await sessionsService?.updateSession({
        platform_id: 'dryvelabs',
        session_id: id,
        agent_id: 'ferdy',
        is_favorite: false,
      });
    },
    retry: 1,
    onSuccess: response => {
      Toast({
        type: 'success',
        message: response.detail,
      });
      queryClient.invalidateQueries({ queryKey: ['sessions'] });
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setChatDropdownOpen(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const Timeline = ['Today', 'Yesterday', 'Last 7 Days', 'Last 30 Days'];
  return (
    <StyledSessionsListSection>
      {isPending ? (
        <Loaders textLoader />
      ) : (
        <>
          {/*------------------- Favorite Sessions List -------------------*/}
          {data?.sessions['Favorite']?.length > 0 && (
            <>
              <span className="subheading2">Favorites</span>
              <ul className="chat-list">
                {data?.sessions?.['Favorite']?.map((chat, index) => (
                  <li
                    key={chat.id}
                    ref={chatDropdownOpen === chat.id ? dropdownRef : null}
                    className={location.pathname?.includes(chat?.id) && 'active'}>
                    <span
                      className="text"
                      onClick={() => {
                        toggleRef(true);
                        navigate(`/chat/${chat?.id}`);
                      }}
                      dangerouslySetInnerHTML={{ __html: chat?.title }}
                    />
                    <MainMenu
                      menuButton={
                        <MenuBtn>
                          <PiDotsThreeOutlineVertical size={18} className="three-dots" />
                        </MenuBtn>
                      }>
                      <StyledMenuItem>
                        <button type="button" onClick={() => handleRemoveFavorite.mutate(chat?.id)}>
                          Remove to Favorites
                        </button>
                      </StyledMenuItem>
                      <ModalContainer
                        width="600"
                        title="Edit Chat Title"
                        content={({ onClose }) => <RenameChatModal onClose={onClose} data={chat} />}
                        btnComponent={({ onClick }) => (
                          <StyledMenuItem onClick={onClick}>
                            <button type="button">Rename</button>
                          </StyledMenuItem>
                        )}
                      />

                      <ModalContainer
                        width="600"
                        title="Delete Chat"
                        content={({ onClose }) => <DeleteChatModal onClose={onClose} data={chat} />}
                        btnComponent={({ onClick }) => (
                          <StyledMenuItem onClick={onClick}>
                            <button type="button" style={{ color: 'rgba(215, 65, 32, 1)' }}>
                              Delete
                            </button>
                          </StyledMenuItem>
                        )}
                      />
                    </MainMenu>
                  </li>
                ))}
              </ul>
            </>
          )}

          {/*------------------- Sessions List History -------------------*/}
          {Timeline?.map((time, index) => (
            <div key={index}>
              {data?.sessions[time]?.length > 0 && (
                <>
                  <span className="subheading2">{time}</span>
                  <ul className="chat-list">
                    {data?.sessions[time]?.map((chat, index) => (
                      <li
                        key={chat.id}
                        ref={chatDropdownOpen === chat.id ? dropdownRef : null}
                        className={location.pathname?.includes(chat?.id) && 'active'}>
                        <span
                          className="text"
                          onClick={() => {
                            toggleRef(true);
                            navigate(`/chat/${chat?.id}`);
                          }}
                          dangerouslySetInnerHTML={{ __html: chat?.title }}
                        />
                        <MainMenu
                          menuButton={
                            <MenuBtn>
                              <PiDotsThreeOutlineVertical size={18} />
                            </MenuBtn>
                          }>
                          <StyledMenuItem>
                            <button type="button" onClick={() => handleAddFavorite.mutate(chat?.id)}>
                              Add to Favorites
                            </button>
                          </StyledMenuItem>

                          <ModalContainer
                            width="600"
                            title="Edit Chat Title"
                            content={({ onClose }) => <RenameChatModal onClose={onClose} data={chat} />}
                            btnComponent={({ onClick }) => (
                              <StyledMenuItem onClick={onClick}>
                                <button type="button">Rename</button>
                              </StyledMenuItem>
                            )}
                          />

                          <ModalContainer
                            width="600"
                            title="Delete Chat"
                            content={({ onClose }) => <DeleteChatModal onClose={onClose} data={chat} />}
                            btnComponent={({ onClick }) => (
                              <StyledMenuItem onClick={onClick}>
                                <button type="button" style={{ color: 'rgba(215, 65, 32, 1)' }}>
                                  Delete
                                </button>
                              </StyledMenuItem>
                            )}
                          />
                        </MainMenu>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          ))}
        </>
      )}
    </StyledSessionsListSection>
  );
};

export default SessionsListSection;
